function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 31,
  height: 31,
  rx: 4.5,
  fill: "#fff"
}), React.createElement("path", {
  d: "M27,1a4,4,0,0,1,4,4V27a4,4,0,0,1-4,4H5a4,4,0,0,1-4-4V5A4,4,0,0,1,5,1H27m0-1H5A5,5,0,0,0,0,5V27a5,5,0,0,0,5,5H27a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5Z",
  fill: "#0074d9"
}), React.createElement("path", {
  d: "M24.31,22H14.59a.5.5,0,0,1,0-1h9.72a.5.5,0,0,1,0,1Z",
  fill: "#6e7482"
}), React.createElement("path", {
  d: "M24.31,16H14.59a.5.5,0,0,1,0-1h9.72a.5.5,0,0,1,0,1Z",
  fill: "#6e7482"
}), React.createElement("path", {
  d: "M24.31,10H14.59a.5.5,0,0,1,0-1h9.72a.5.5,0,0,1,0,1Z",
  fill: "#6e7482"
}), React.createElement("path", {
  d: "M10.92,13.9H9.55V11.26c0-.32,0-.62,0-.88a3.21,3.21,0,0,1-.32.32l-.56.47L8,10.3,9.7,8.91h1.22Z",
  fill: "#6e7482"
}), React.createElement("path", {
  d: "M11.53,22.05H7.9v-.89l1.22-1.24c.35-.36.58-.61.68-.74a2.05,2.05,0,0,0,.23-.35.73.73,0,0,0,.06-.3.39.39,0,0,0-.13-.31.52.52,0,0,0-.35-.11,1,1,0,0,0-.48.14,3.55,3.55,0,0,0-.54.39l-.75-.86a4.58,4.58,0,0,1,.65-.5,2.25,2.25,0,0,1,.58-.22A2.42,2.42,0,0,1,9.76,17a2,2,0,0,1,.87.17,1.34,1.34,0,0,1,.59.48,1.28,1.28,0,0,1,.21.71,1.93,1.93,0,0,1-.07.55,2.16,2.16,0,0,1-.23.49,3.39,3.39,0,0,1-.41.51c-.17.17-.53.51-1.08,1v0h1.89Z",
  fill: "#6e7482"
})));

function SvgOrder(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/order.fa86a711.svg";
export { SvgOrder as ReactComponent };